// src/components/titlebar/components/ServerMenu.tsx

import React from "react"
import { Box, Menu, MenuItem } from "@mui/material"
import { Storage as ServerIcon } from "@mui/icons-material"
import { ServerMenuButton, menuPaperStyle } from "../styles/titleBarStyles"
import type { ServerMenuProps } from "../types/titleBarTypes"

const ServerMenu: React.FC<ServerMenuProps> = ({
  anchorEl,
  currentServerPcName,
  currentServer,
  discoveredServers,
  hospitalName,
  onOpen,
  onClose,
  onServerConnectMenuOpen,
  onServerConnectMenuClose,
  onServerConnect,
  onServerSearch,
  onConnectToServer,
  serverConnectMenuAnchor,
}) => {
  return (
    <>
      <ServerMenuButton startIcon={<ServerIcon sx={{ fontSize: 14 }} />} onClick={onOpen} sx={{ marginLeft: "8px" }}>
        서버 - {currentServerPcName || currentServer || "미연결"}
      </ServerMenuButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            ...menuPaperStyle,
            minWidth: 200,
          },
        }}
      >
        <MenuItem onClick={onServerConnectMenuOpen}>
          서버연결
          <Box
            component="span"
            sx={{
              ml: "auto",
              width: 0,
              height: 0,
              borderLeft: "4px solid rgba(0, 0, 0, 0.54)",
              borderTop: "3px solid transparent",
              borderBottom: "3px solid transparent",
            }}
          />
        </MenuItem>
        <MenuItem onClick={onServerSearch}>서버검색</MenuItem>

        {/* 발견된 서버 목록 표시 */}
        {discoveredServers.length > 0 && [
          <MenuItem key="server-list-header" disabled sx={{ fontWeight: "bold", color: "primary.main" }}>
            발견된 서버 목록:
          </MenuItem>,
          ...discoveredServers.map((server, index) => (
            <MenuItem
              key={`server-${index}`}
              onClick={() => onConnectToServer(server)}
              sx={{
                paddingLeft: 3,
                fontSize: "0.9rem",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                },
              }}
            >
              📡 {server}
            </MenuItem>
          )),
        ]}

        <MenuItem divider />
        <MenuItem onClick={() => window.electronAPI?.close()}>종료</MenuItem>
      </Menu>

      {/* 서버연결 서브메뉴 */}
      <Menu
        anchorEl={serverConnectMenuAnchor}
        open={Boolean(serverConnectMenuAnchor)}
        onClose={onServerConnectMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            ...menuPaperStyle,
            ml: 0.5,
            minWidth: 180,
          },
        }}
      >
        <MenuItem onClick={onServerConnect}>기본서버: {currentServerPcName || currentServer || "미연결"}</MenuItem>
      </Menu>
    </>
  )
}

export default ServerMenu
